import {
  ColDef,
  IServerSideGetRowsParams,
  GridReadyEvent,
} from "ag-grid-community";
import AgGrid from "../../../UI/AgGrid";
import { RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import { createGraphQLClientWithMiddleware } from "../../../../services/graphqlClient";
import { GraphQLClient } from "graphql-request";
import { SALES_ITEM_BY_BRANCH_EXPORT_VIEW } from "../../../../services/AgGrid/Report/SalesReportAggrid";

interface Props {
  gridRef: RefObject<AgGridReact>;
}

const SalesByBranchReportTable = ({ gridRef }: Props) => {

  const columnDefs: ColDef[] = [
    {
      field: "branch_id",
      headerName: "รหัสสาขา",
      filter: "agTextColumnFilter",
    },
    {
      field: "branch_name",
      headerName: "สาขา",
      filter: "agTextColumnFilter",
    },
    {
      field: "unique_id",
      headerName: "รหัสสินค้า",
      filter: "agTextColumnFilter",
    },
    {
      field: "item_name",
      headerName: "ชื่อสินค้า",
      filter: "agTextColumnFilter",
    },
    {
      field: "qty",
      headerName: "จำนวน",
      filter: "agNumberColumnFilter",
    },
    {
      field: "uom_name",
      headerName: "หน่วย",
      filter: "agTextColumnFilter",
    },
    {
      field: "item_pre_discount_amount",
      headerName: "มูลค่าก่อนหักส่วนลด",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) =>
        params.value ? params.value.toLocaleString() : 0,
      cellStyle: { display: "flex", justifyContent: "flex-end" },
    },
    {
      field: "item_discount",
      headerName: "ส่วนลด",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) =>
        params.value ? params.value.toLocaleString() : 0,
      cellStyle: { display: "flex", justifyContent: "flex-end" },
    },
    {
      field: "item_additional_discount",
      headerName: "ส่วนลดเพิ่มเติม",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) =>
        params.value ? params.value.toLocaleString() : 0,
      cellStyle: { display: "flex", justifyContent: "flex-end" },
    },
    {
      field: "post_discount_amount",
      headerName: "มูลค่าหลังหักส่วนลด",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) =>
        params.value ? params.value.toLocaleString() : 0,
      cellStyle: { display: "flex", justifyContent: "flex-end" },
    },
    {
      field: "item_vat_amount",
      headerName: "ภาษีมูลค่าเพิ่ม",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) =>
        params.value ? params.value.toLocaleString() : 0,
      cellStyle: { display: "flex", justifyContent: "flex-end" },
    },
    {
      field: "item_net_amount",
      headerName: "มูลค่ารวมสุทธิ",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) =>
        params.value ? params.value.toLocaleString() : 0,
      cellStyle: { display: "flex", justifyContent: "flex-end" },
    },
    {
      field: "item_withholding_tax_amount",
      headerName: "ภาษีหัก ณ ที่จ่าย",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) =>
        params.value ? params.value.toLocaleString() : 0,
      cellStyle: { display: "flex", justifyContent: "flex-end" },
    },
    {
      field: "total_amount",
      headerName: "จำนวนเงินชำระทั้งสิ้น",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) =>
        params.value ? params.value.toLocaleString() : 0,
      cellStyle: { display: "flex", justifyContent: "flex-end" },
    },
    {
      field: "item_qty_to_ship",
      headerName: "รอส่ง",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) =>
        params.value ? params.value.toLocaleString() : 0,
      cellStyle: { display: "flex", justifyContent: "flex-end" },
    },
    {
      field: "item_qty_shipped",
      headerName: "ส่งแล้ว",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) =>
        params.value ? params.value.toLocaleString() : 0,
      cellStyle: { display: "flex", justifyContent: "flex-end" },
    },
    {
      field: "item_qty_invoiced",
      headerName: "แจ้งหนี้แล้ว",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) =>
        params.value ? params.value.toLocaleString() : 0,
      cellStyle: { display: "flex", justifyContent: "flex-end" },
    },
    {
      field: "item_qty_returned",
      headerName: "คืนของ",
      filter: "agNumberColumnFilter",
      valueFormatter: (params) =>
        params.value ? params.value.toLocaleString() : 0,
      cellStyle: { display: "flex", justifyContent: "flex-end" },
    },
  ];

  const graphQLClient: GraphQLClient =
    createGraphQLClientWithMiddleware("sales");

  const datasource = {
    async getRows(params: IServerSideGetRowsParams) {
      const { request } = params;
      const { startRow, endRow, filterModel, sortModel } = request;

      const formatFilter = {
        ...filterModel,
      };

      try {
        const { SalesItemByBranchExportViewsAggrid } =
          await graphQLClient.request(SALES_ITEM_BY_BRANCH_EXPORT_VIEW, {
            aggridInput: {
              startRow,
              endRow,
              filterModel: formatFilter,
              sortModel,
            },
          });
        params.success({
          rowData: SalesItemByBranchExportViewsAggrid.results,
          rowCount: SalesItemByBranchExportViewsAggrid.count,
        });
      } catch (err) {
        params.fail();
      }
    },
  };

  const onGridReady = (params: GridReadyEvent) => {
    params.api.setServerSideDatasource(datasource);
  };

  return (
    <AgGrid
      height={665}
      ref={gridRef}
      columnDefs={columnDefs}
      onGridReady={onGridReady}
    />
  );
};

export default SalesByBranchReportTable;
